export default __webpack_public_path__ + "static/media/displayPicture.f5bbe167.png";